import dayjs from "dayjs";

export let dayFormat = data => //时间格式化
  dayjs(data).format("YYYY-MM-DD");

export let timeFormat = data =>  //时间格式化
  dayjs(data).format("YYYY-MM-DD HH:mm:ss");

export let activityTime = (data, format = 'YYYY-MM-DD HH:mm') =>  //时间格式化
  dayjs(data).format(format);

